let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6UhLI")).then(() => parcelRequire('h8WYC'));